// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "logo-3CTOz";
export { _1 as "__esModule", _2 as "logo" }
export default { "__esModule": _1, "logo": _2 }
